import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';

//pages
import Authentication from './pages/authentication/authentication';
import ContentPage from './pages/contentPage/contentPage';
import CultureSelect from './pages/cultureSelect/cultureSelect';
import LandingPage from './pages/landingPage/landingPage';
import PageNotFound from './pages/pageNotFound/pageNotFound';

//assets
import './App.css';

class App extends Component {
	render() {
		return (
			<Switch>
				<Route exact path="/" component={CultureSelect} />
				<Route path="/page-not-found" component={PageNotFound} />
				<Route path="/:culture/page-not-found" component={PageNotFound} />
				<Route path="/:culture/:section/page-not-found" component={PageNotFound} />
				<Route path="/:culture/:section/authentication/:key1/:key2" component={Authentication} />
				<Route exact path='/:culture' render={(props) => (
					<LandingPage {...props} />
				)}/>
				<Route exact path='/:culture/:section' render={(props) => (
					<ContentPage {...props} />
				)}/>
				<Route exact path='/:culture/:section/:page' render={(props) => (
					<ContentPage {...props} />
				)}/>
				<Route path="*" component={PageNotFound} />
			</Switch>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js